import "core-js/modules/es.array.find";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.parse-int";
import { getMsaAliasToId } from 'dynamic-data/msa-alias-to-id';
export var MSA_ALIAS_TO_ID = getMsaAliasToId();
export var msaAliasToId = function msaAliasToId(alias) {
  return MSA_ALIAS_TO_ID[alias] || null;
};
export var msaIdToAlias = function msaIdToAlias(id) {
  return Object.keys(MSA_ALIAS_TO_ID).find(function (key) {
    return MSA_ALIAS_TO_ID[key] === parseInt(id, 10);
  });
};